<template>
    <div v-observe-visibility="visibilityChanged">
        <v-layout row justify-center>
            <v-dialog v-model="removeDialog" persistent max-width="350">
                <v-card>
                    <v-card-title class="headline">Delete item?</v-card-title>
                    <v-card-text>This action deletes selected item from Database, be carefull!</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary darken-1" flat @click.native="removeDialog = false">Cancel</v-btn>
                        <v-btn color="primary darken-1" flat
                               @click.native="removeBranchOfficeContact(branchOfficeContactToDelete)">OK
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <v-layout row wrap ma-2>
            <v-flex xs12 md4 ma-2>
                <v-card dark color="secondary">
                    <v-card-title>Branch Office</v-card-title>
                </v-card>
                <v-progress-linear class="branch-office-contacts-loading" :active="loading"
                                   :indeterminate="true"></v-progress-linear>

                <v-autocomplete
                        :items="supplierBranchOffices"
                        item-text="name"
                        item-value="id"
                        label="Select Branch Office"
                        v-model="selectedBranchOffice"
                        required
                ></v-autocomplete>
            </v-flex>
        </v-layout>

        <v-layout row wrap ma-2>
            <v-flex xs12 md4 ma-2>
                <v-flex xs12>
                    <v-card dark color="secondary">
                        <v-card-title>Contact Persons</v-card-title>
                    </v-card>
                    <v-progress-linear class="branch-office-contacts-loading" :active="loading"
                                       :indeterminate="true"></v-progress-linear>
                </v-flex>
                <v-flex xs12>
                    <v-list class="branchOfficesContactsList" two-line subheader>

                        <template v-for="(item, index) in branchOfficeContacts">
                            <v-list-tile avatar
                                         @click="editItem(index)">
                                <v-list-tile-avatar>
                                    <v-icon>account_circle</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{item.firstname}} {{item.lastname}}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title>{{item.email}} - {{item.phone}} - {{item.mobile}}
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-btn icon ripple @click="showDeleteDialog(index)">
                                        <v-icon color="red lighten-1">delete</v-icon>
                                    </v-btn>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-divider></v-divider>
                        </template>
                    </v-list>
                </v-flex>
                <v-flex v-if="branchOfficeContacts == null || branchOfficeContacts.length <= 0">
                    <v-card-text><p class="text-xs-center grey--text">No Contact Persons yet</p></v-card-text>
                </v-flex>

                <v-layout mt-5 row justify-end>
                    <v-btn :disabled="addButtonDisabled" mt-5 class="secondary white--text"
                           @click="addNewContactPerson">Add
                        <v-icon class="white--text" right>add</v-icon>
                    </v-btn>
                </v-layout>

            </v-flex>

            <v-flex xs12 md7 ma-2>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-card dark color="secondary">
                            <v-card-title>Person Details</v-card-title>
                        </v-card>
                    </v-flex>

                    <v-flex xs12 md2 ma-2 ml-3>
                        <v-select :disabled="formDisabled"
                                  :items=salutions
                                  label="Salution"
                                  v-model="getSelectedBranchOfficeContact.salution"
                                  required
                        ></v-select>

                    </v-flex>

                    <v-flex xs12 md3 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeContact.title"
                                      label="Title"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeContact.firstname"
                                      label="Firstname"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeContact.lastname"
                                      label="Lastname"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeContact.email"
                                      label="Email"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeContact.phone"
                                      label="Phone"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeContact.mobile"
                                      label="Mobile"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 pl-3 py-2>
                        <v-text-field :disabled="formDisabled"
                                      v-model="getSelectedBranchOfficeContact.fax"
                                      label="Fax"></v-text-field>
                    </v-flex>

                    <v-flex xs12 md6 pl-3 py-3>
                        <v-autocomplete :disabled="formDisabled"
                                        label="Contact Function"
                                        persistent-hint
                                        v-model="getSelectedBranchOfficeContact.contacts_functions_id"
                                        item-value="id"
                                        item-text="name"
                                        :items="contactFunctions"
                        ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md6 pl-3 py-2>
                        <v-autocomplete :disabled="needIdToSave"
                                        label="Manufacturers"
                                        multiple
                                        chips
                                        persistent-hint
                                        :deletable-chips=chipsDeletable
                                        v-model="selectedManufacturers"
                                        item-value="manufacturer_id"
                                        item-text="manufacturer_name"
                                        :items="getBranchOfficeHasManufacturers"

                        >

                            <template v-slot:prepend-item>
                                <v-list-tile
                                        ripple
                                        @click="toggle"

                                >
                                    <v-list-tile-action>
                                        <v-icon :color="selectedManufacturers.length > 0 ? 'primary' : 'secondary'" >{{icon}}</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Select All</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                        </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 md3 pl-3 py-2>
                        <v-switch :disabled="needIdToSave" color="secondary" label="Main Contact"
                                  v-model="getSelectedBranchOfficeContact.main_contact"></v-switch>
                    </v-flex>

                </v-layout>

                <v-layout mt-5 row justify-end>
                    <v-btn :disabled="formEdited" mt-5 class="secondary white--text"
                           @click.native="saveContactPersons(3)">Save
                        <v-icon class="white--text" right>save</v-icon>
                    </v-btn>
                </v-layout>

            </v-flex>
        </v-layout>

    </div>
</template>

<script>
/* eslint-disable */
    import {
        ManufacturersSettings,
        Settings,
        ContactFunctionsSettings,
        ContactPersonSettings
    } from '../../../store/namespace-helper'

    export default {
      name: 'contact-persons',
      data () {
        return {
          countries: this.$store.getters.countries,
          isVisible: false,
          supplierBranchOffice: {},
          removeDialog: false,
          branchOfficeContactToDelete: null,
          onDismissed: false,
          contactPersonsUpdated: 0,
          selectedBranchOffice: null,
          salutions: [
            'Mr.',
            'Mrs.',
            'Company'
          ],
          chipsDeletable: true,
          selectedManufacturers: []
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              this.loadSupplierBranchOffices()
              this.loadAllContactFunctions()
            } else {
              this.branchOfficeUpdated = 0
              this.selectedBranchOffice = null
            }
          }
        },
        loadSupplierBranchOffices () {
          this.$store.dispatch(Settings.actions.loadSupplierBranchOffices, this.selectedSupplier.id)
        },
        loadContactPersons (branchOfficeID) {
          this.$store.dispatch(ContactPersonSettings.actions.loadContactPersons, branchOfficeID)
        },
        loadAllContactFunctions () {
          this.$store.dispatch(ContactFunctionsSettings.actions.loadAllContactFunctions)
        },
        loadBranchOfficeHasManufacturers (branchOfficeID) {
          this.$store.dispatch(ManufacturersSettings.actions.loadBranchOfficeHasManufacturers, branchOfficeID)
        },
        loadContactPersonHasManufacturers (contactPersonID) {
          this.$store.dispatch(ContactPersonSettings.actions.loadContactPersonHasManufacturers, contactPersonID)
        },
        editItem (index) {
          this.$store.dispatch(ContactPersonSettings.actions.setSelectedContactPerson, this.branchOfficeContacts[index])
          this.selectedManufacturers = []
          this.loadContactPersonHasManufacturers(this.branchOfficeContacts[index].id)
        },
        showDeleteDialog (index) {
          this.removeDialog = true
          this.branchOfficeContactToDelete = index
        },
        removeBranchOfficeContact (index) {
          this.removeDialog = false
          this.$store.dispatch(ContactPersonSettings.actions.removeContactPerson, this.branchOfficeContactToDelete)
          this.contactPersonsUpdated = 0
        },
        addNewContactPerson () {
          let contactPerson = {
            id: null,
            salution: null,
            title: null,
            firstname: 'Firstname',
            lastname: 'Lastname',
            email: null,
            phone: null,
            fax: null,
            mobile: null,
            main_contact: false,
            contacts_functions_id: null,
            suppliers_branch_offices_id: this.selectedBranchOffice
          }
          this.$store.dispatch(ContactPersonSettings.actions.addNewContactPerson, contactPerson)
          this.$store.dispatch(ContactPersonSettings.actions.setSelectedContactPerson, contactPerson)
        },
        saveContactPersons (index) {
          console.log('this.getSelectedBranchOfficeContact.id: ' + this.getSelectedBranchOfficeContact.id)
          this.$store.dispatch(ContactPersonSettings.actions.saveContactPerson, this.branchOfficeContacts)
          let contactPersonHasManufacturers = []
          let contactPersonId = this.getSelectedBranchOfficeContact.id
          this.selectedManufacturers.forEach(function (element) {
            let tempItem = {
              contact_person_id: contactPersonId,
              manufacturer_id: element
            }
            contactPersonHasManufacturers.push(tempItem)
          })
          let contactPersonToManufacturerMapping = {
            contact_person_id: contactPersonId,
            supplier_contact_has_manufacturers: contactPersonHasManufacturers

          }
          this.$store.dispatch(ContactPersonSettings.actions.saveSupplierContactHasManufacturers, contactPersonToManufacturerMapping)

          this.contactPersonsUpdated = 0
        },
        toggle () {
          this.$nextTick(() => {
            if (this.allManufacturersSelected) {
              this.selectedManufacturers = []
            } else {
              this.selectedManufacturers = this.getBranchOfficeHasManufacturers.map(a => a.manufacturer_id)
            }
          })
        }

      },
      computed: {
        selectedSupplier () {
          return this.$store.getters[Settings.getters.getSelectedSupplier]
        },
        supplierBranchOffices () {
          if (this.$store.getters[Settings.getters.getSupplierBranchOffices] == null) {
            return []
          }
          return this.$store.getters[Settings.getters.getSupplierBranchOffices]
        },
        contactFunctions () {
          return this.$store.getters[ContactFunctionsSettings.getters.getAllContactFunctions]
        },
        branchOfficeContacts () {
          return this.$store.getters[ContactPersonSettings.getters.getContactPersons]
        },
        getSelectedBranchOfficeContact () {
          return this.$store.getters[ContactPersonSettings.getters.getSelectedContactPerson]
        },
        getBranchOfficeHasManufacturers () {
          return this.$store.getters[ManufacturersSettings.getters.getBranchOfficeHasManufacturers]
        },
        getContactPersonHasManufacturers () {
          return this.$store.getters[ContactPersonSettings.getters.getContactPersonsHasManufactures]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        formEdited () {
          console.log('branch office formEdited: ' + this.contactPersonsUpdated)
          return this.contactPersonsUpdated < 2
        },
        addButtonDisabled () {
          return this.selectedBranchOffice === null
        },
        formDisabled () {
          return this.getSelectedBranchOfficeContact.id === 0
        },
        needIdToSave () {
          return this.getSelectedBranchOfficeContact.id === 0 || this.getSelectedBranchOfficeContact.id === null
        },
        allManufacturersSelected () {
          return this.selectedManufacturers.length === this.getBranchOfficeHasManufacturers.length
        },
        someManufacturersSelected () {
          return this.selectedManufacturers.length > 0 && !this.allManufacturersSelected
        },
        icon () {
          if (this.allManufacturersSelected) return 'check_box'
          if (this.someManufacturersSelected) return 'indeterminate_check_box'
          return 'check_box_outline_blank'
        }

      },
      watch: {
        selectedManufacturers: {
          handler (val) {
            console.log('selectedManufacturers data changed: ' + JSON.stringify(val))
            this.contactPersonsUpdated++
          },
          deep: true
        },
            /*            getSelectedBranchOfficeContact: {
                            handler(val) {
                                console.log("getSelectedBranchOfficeContact data changed: " + JSON.stringify(val))
                                this.selectedManufacturers = []
                                //this.loadContactPersonHasManufacturers(val.id)

                            },
                            deep: true
                        }, */
        getContactPersonHasManufacturers: {
          handler (val) {
            console.log('getContactPersonHasManufacturers data changed: ' + JSON.stringify(val))
            this.selectedManufacturers = []
            let tempSelectedManufacturers = []
            this.getContactPersonHasManufacturers.forEach(function (element) {
              tempSelectedManufacturers.push(element.manufacturer_id)
            })
            this.selectedManufacturers = tempSelectedManufacturers
          },
          deep: true
        },
        branchOfficeContacts: {
          handler (val) {
            console.log('branchOfficeContacts data changed: ' + JSON.stringify(val))
            this.contactPersonsUpdated++
          },
          deep: true
        },
        selectedBranchOffice: {
          handler (val) {
            console.log('selectedBranchOffice data changed: ' + JSON.stringify(val))
            this.$store.dispatch(ContactPersonSettings.actions.setContactPersons, [])
            this.loadContactPersons(val)
            this.loadBranchOfficeHasManufacturers(val)
            this.$store.dispatch(ContactPersonSettings.actions.setSelectedContactPerson, null)
            this.selectedManufacturers = []
          },
          deep: true
        }
      }
    }
</script>

<style scoped>

    .branchOfficesContactsList {
        max-height: 50vh;
        overflow: scroll;
        margin-top: -20px;
    }

    .branchOfficesContactsList::-webkit-scrollbar {
        display: none;
    }

    .branch-office-contacts-loading {
        margin-top: 0px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Settings/Suppliers/ContactPersons.vue